import { id } from './id';

export function elementAttributeValues(
  element,
  pattern,
  replacement,
  deep = true,
) {
  if (element.hasAttributes()) {
    for (const attribute of element.attributes) {
      if (typeof pattern === 'string') {
        if (attribute.value === pattern) attribute.value = replacement;

        continue;
      }

      if (pattern instanceof RegExp) {
        attribute.value = attribute.value.replace(pattern, replacement);
      }
    }
  }

  if (deep) {
    if (element.tagName === 'TEMPLATE' && element.content) {
      for (const child of element.content.children) {
        elementAttributeValues(child, pattern, replacement, deep);
      }
      return;
    }

    if (element.children) {
      for (const child of element.children) {
        elementAttributeValues(child, pattern, replacement, deep);
      }
    }
  }
}

export function elementIds(
  element,
  fn = currentId => id(`${currentId}-`),
  deep = true,
) {
  const ids = [
    ...(element.hasAttribute('id') ? [element] : []),
    ...(deep ? element.querySelectorAll('[id]') : []),
  ].map(el => el.id);

  for (const id of ids) {
    elementAttributeValues(element, id, fn(id), deep);
  }
}

export function elementSize(element, unit = false) {
  const { height, width } = element.getBoundingClientRect();

  if (unit) {
    return {
      height: `${height}px`,
      width: `${width}px`,
    };
  }

  return {
    height,
    width,
  };
}

export function elementStyle(element, props = null) {
  const computed = window.getComputedStyle(element);
  const properties = props ? (Array.isArray(props) ? props : [props]) : [...computed];
  const values = Object.fromEntries(properties.map(prop => [ prop, computed.getPropertyValue(prop) ]));

  return Object.keys(values).length > 1 ? values : Object.values(values)[0];
}

// NOTE: fallback for checkVisbility() in safari <17.4
export function elementVisible(element) {
  if (element.checkVisibility) return element.checkVisibility();

  const {
    height,
    width,
  } = elementSize(element);
  const {
    display,
    opacity,
    visibility,
  } = elementStyle(element, [ 'display', 'opacity', 'visibility' ]);

  return height > 0
         && width > 0
         && display !== 'none'
         && opacity > 0
         && visibility !== 'hidden';
}
